import React, { useState } from 'react';
import { FiX } from 'react-icons/fi';
import axios from 'axios';
import { toast } from 'react-toastify';

const AddTrendingModal = ({ onClose, onAdd }) => {
  const [formData, setFormData] = useState({
    image: null,
    type: 'trending',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const API_BASE_URL = process.env.REACT_APP_BACKEND_API;

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'image') {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const formPayload = new FormData();
      formPayload.append('image', formData.image);
      formPayload.append('type', formData.type);

      const response = await axios.post(
        `${API_BASE_URL}/add-featured`,
        formPayload,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (response.data && response.data.product) {
        onAdd(response.data.product); // Add the new product to the list
        toast.success('Product added successfully!');
        onClose();
      }
    } catch (error) {
      console.error('Error adding product:', error);
      toast.error(
        error.response?.data?.error ||
          'Failed to add product. Please try again.'
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold">Add Featured Product</h3>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
            disabled={isSubmitting}
          >
            <FiX size={24} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="space-y-4">
            {/* Image Selection */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Select Image
              </label>
              <input
                type="file"
                name="image"
                accept="image/*"
                onChange={handleChange}
                className="w-full border rounded-md px-3 py-2"
                required
                disabled={isSubmitting}
              />
              {formData.image && (
                <p className="text-xs text-gray-500 mt-1">
                  Selected: {formData.image.name}
                </p>
              )}
            </div>

            {/* Type Selection */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Type
              </label>
              <select
                name="type"
                value={formData.type}
                onChange={handleChange}
                className="w-full border rounded-md px-3 py-2"
                disabled={isSubmitting}
              >
                <option value="trending">Trending</option>
                <option value="bestseller">Bestseller</option>
              </select>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="mt-6 flex justify-end space-x-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border rounded-md hover:bg-gray-100"
              disabled={isSubmitting}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 disabled:bg-indigo-400"
              disabled={isSubmitting || !formData.image}
            >
              {isSubmitting ? 'Adding...' : 'Add Product'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddTrendingModal;